import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, Subscription } from 'rxjs';
import { StateManagementService } from '../../shared/services/state-management.service';
import { roleAccess } from '../../shared/services/state-management.service';
@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  buttons = ['Save', 'Cancel', 'Delete'];
  private router = inject(Router);
  private auth = inject(AuthService);
  private stateManagementService = inject(StateManagementService);
  isMobileMenuOpen: boolean = false;
  isAuthenticated: boolean = false;
  userName: string = '';
  isSuperAdmin: boolean = false;
  authChangeSubscription: Subscription = new Subscription();
  userInfoSubscription: Subscription = new Subscription();
  isValidUserSubscription: Subscription = new Subscription();
  superAdminSubscription: Subscription = new Subscription();
  isValidUser: boolean = false;
  isValidationPage: string | null = null;
  private authChannel = new BroadcastChannel('auth');


  constructor() {
    this.loadFromStorage();
    this.subscribeToAuthEvents();
  }

  private loadFromStorage(): void {
    this.isAuthenticated = this.stateManagementService.getLocalStorage('isAuthenticated') === 'true';
    this.isValidUser = this.stateManagementService.getLocalStorage('isValidUser') === 'true';
    this.userName = this.getFirstName();
  }

  private getFirstName(displayName = ''): string {
    const userValue = this.stateManagementService.getLocalStorage('userValue');
    if (userValue) {
      try {
        const user = JSON.parse(userValue) as { name?: string; firstName?: string; lastName?: string; email?: string };
        const firstName = user.firstName?.trim();
        if (firstName) return firstName;
        displayName = user.name?.trim() || displayName;
      } catch { /* ignore */ }
    }

    const name = displayName.trim();
    return name && !name.includes('@') ? name.split(/\s+/)[0] : 'User';
  }

  ngOnInit(): void {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isValidationPage = this.router.url.split('?')[0];
        console.log('Current URL:', this.router.url);
      });
  }

  navItems: any = [
    { label: 'Report Dashboard', path: '/dashboard', icon: this.getIcon('dashboard'), exact: false, superAdminOnly: false, show: false },
    { label: 'Knowledge Base', path: '/kb', icon: this.getIcon('kb'), exact: false, superAdminOnly: false, show: false },
    { label: 'Manage Users', path: '/users', icon: this.getIcon('users'), exact: false, superAdminOnly: true, show: true },
    { label: 'Manage Roles', path: '/roles', icon: this.getIcon('roles'), exact: false, superAdminOnly: true, show: true },
    { label: 'Manage Reports', path: '/reports', icon: this.getIcon('reports'), exact: false, superAdminOnly: true, show: true },
  ];

  get mainLinks() {
    for (const item of this.navItems) {
      if (item.label === 'Report Dashboard') {
        item.show = this.checkAccess(item.label);
      } else if (item.label === 'Knowledge Base') {
        item.show = this.checkAccess(item.label);
      }
      //console.log(item);
    }
    return this.navItems.filter((item: any) => !item.superAdminOnly || this.isSuperAdmin);
  }

  checkAccess(label: any): boolean {
    //console.log('Checking access for:', label);
    var returnvalue = false;
    if (label === 'Report Dashboard') {
      returnvalue = this.decodeJwtPayload(this.stateManagementService.getLocalStorage('userRoleAccessToken') || '', 'Report Dashboard');
      //console.log(returnvalue);
      return returnvalue;
    } else if (label === 'Knowledge Base') {
      returnvalue = this.decodeJwtPayload(this.stateManagementService.getLocalStorage('userRoleAccessToken') || '', 'Knowledge Base') //(this.stateManagementService.roleAccessSubject.getValue()?.rolePermissions?.knowledgeBase?.view || this.stateManagementService.roleAccessSubject.getValue()?.rolePermissions?.knowledgeBase?.manage)|| false;
      //console.log(returnvalue);
      return returnvalue;
    } else {
      return false;
    }
    //return false;
  }

  private decodeJwtPayload(token: string, data: string): boolean {
    if (!token) {
      return false;
    }
    const decoded = JSON.parse(token) as roleAccess | null;
    var access: boolean = false;
    if (data == 'Report Dashboard') {
      access = decoded?.rolePermissions?.reports.view == true;
    } else if (data == 'Knowledge Base') {
      access = (decoded?.rolePermissions?.knowledgeBase.view == true || decoded?.rolePermissions?.knowledgeBase.manage == true);
    }
    //console.log(access);
    return access;
  }

  private getIcon(type: string): string {
    const icons: { [key: string]: string } = {
      dashboard: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>',
      users: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>',
      reports: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 3h18v18H3V3z"></path><path d="M3 9h18"></path><path d="M9 21V9"></path></svg>',
      roles: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 3h18v18H3V3z"></path><path d="M3 9h18"></path><path d="M9 21V9"></path></svg>',
      kb: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 3h18v18H3V3z"></path><path d="M3 9h18"></path><path d="M9 21V9"></path></svg>',
    };
    return icons[type] || icons['dashboard'];
  }

  logout() {
    console.log('Logging out...');
    this.stateManagementService.clearAuthStateForLogout();
    const channel = new BroadcastChannel('auth');
    channel.postMessage('logout');
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin + "/login"
      }
    });
  }

  login() {
    console.log('Initiating login...');
    this.auth.loginWithRedirect({
      authorizationParams: {
        prompt: 'login'
      }
    });
  }

  subscribeToAuthEvents(): void {
    this.authChangeSubscription = this.stateManagementService.getAuthenticationStatus().subscribe(isAuthenticated => {
      this.isAuthenticated = isAuthenticated;
      console.log('Authentication status changed:', isAuthenticated);
    });

    this.userInfoSubscription = this.stateManagementService.getUserName().subscribe(userName => {
      this.userName = this.getFirstName(userName);
      console.log('User name updated:', userName);
    });

    this.isValidUserSubscription = this.stateManagementService.getIsValidUser().subscribe(isValidUser => {
      this.isValidUser = isValidUser;
      console.log('User validity status updated:', isValidUser);
    });

    this.superAdminSubscription = this.stateManagementService.getIsSuperAdmin().subscribe((isSuperAdmin) => {
      this.isSuperAdmin = isSuperAdmin;
    });
  }

  ngOnDestroy() {
    this.authChangeSubscription.unsubscribe();
    this.userInfoSubscription.unsubscribe();
    this.isValidUserSubscription.unsubscribe();
    this.superAdminSubscription.unsubscribe();
  }
}
